<template>
    <div>




        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Метатеги</h3>
                    </div>
                    <div class="card-body">

                        <b-form-group class="mt-0" description="Введите тег заголовок" label="Заголовок:">
                            <b-form-input v-model.trim="home.title" placeholder="Введите тег Заголовок"></b-form-input>
                        </b-form-group>

                        <b-form-group class="mt-0" description="Введите тег Description" label="Description:">
                            <b-form-textarea placeholder="Введите тег Description" v-model.trim="home.description"></b-form-textarea>
                        </b-form-group>


                        <a @click="saveTags" ref="save-meta" class="btn btn-block btn-sm btn-light-success font-weight-bolder text-uppercase py-4 ">Сохранить метатеги</a>

                    </div>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Слайдер</h3>
                        <div class="card-toolbar">
                        </div>
                    </div>
                    <div class="card-body">

                            <draggable class="row" :list="home.slides" :options="{animation:400, handle: '.handle'}"  @change="updateSortSlider" tag="div">
                            <div v-bind:key="i" v-for="(slide, i) in home.slides" class="col-xl-4 col-lg-6 col-md-6 col-sm-6 handle">
                                <div class="card card-custom gutter-b card-stretch">
                                    <div class="card-body pt-4">

                                        <div v-if="slide.image" class="d-flex align-items-center mb-7">
                                            <b-img :src="$urlBackEnd(slide.image)" fluid-grow alt="Fluid-grow image"></b-img>
                                        </div>

                                        <div class="mb-7">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <span class="text-dark-75 font-weight-bolder mr-2">{{slide.title}}</span>
                                            </div>
                                            <div class="d-flex justify-content-between align-items-center">
                                                <span class="text-dark-75 font-weight-bolder mr-2">{{slide.subtitle}}</span>
                                            </div>
                                            <div class="d-flex justify-content-between align-items-cente my-1">
                                                <span class="text-dark-75 font-weight-bolder mr-2">Кнопка:</span>
                                                <span class="text-muted font-weight-bold">{{slide.text_link}}</span>
                                            </div>
                                        </div>
                                        <!--end::Info-->
                                        <a @click="editSlide(slide)" class="btn btn-block btn-sm btn-light-success font-weight-bolder text-uppercase py-4">Редактировать</a>
                                    </div>
                                    <!--end::Body-->
                                </div>
                                <!--end::Card-->
                            </div>
                            </draggable>

                        <a @click="newSlider" class="btn btn-block btn-sm btn-light-success font-weight-bolder text-uppercase py-4 ">Добавить слайдер</a>

                    </div>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Сервисы</h3>
                        <div class="card-toolbar">
                        </div>
                    </div>
                    <div class="card-body">

                        <div class="row">

                            <div v-bind:key="i" v-for="(item, i) in home.service" class="col-xl-3 col-lg-6 col-md-6 col-sm-6">
                                <div class="card card-custom gutter-b card-stretch">
                                    <div class="card-body pt-4">

                                        <b-form>
                                            <b-form-group class="mt-0" description="Введите заголовок" label="Заголовок:">
                                                <b-form-input v-model.trim="item.title" placeholder="Введите Заголовок"></b-form-input>
                                            </b-form-group>

                                            <b-form-group class="mt-0" description="Введите подзаголовок" label="Подзаголовок:">
                                                <b-form-textarea placeholder="Введите подзаголовок" v-model.trim="item.subtitle"></b-form-textarea>
                                            </b-form-group>
                                        </b-form>
                                    </div>
                                    <!--end::Body-->
                                </div>
                                <!--end::Card-->
                            </div>
                        </div>

                        <a @click="saveService" ref="save-service-button" class="btn btn-block btn-sm btn-light-success font-weight-bolder text-uppercase py-4 ">Сохранить</a>

                    </div>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">О нас</h3>
                        <div class="card-toolbar">
                        </div>
                    </div>
                    <div class="card-body">

                        <div class="row">

                            <div v-bind:key="i" v-for="(item, i) in home.about" class="col-xl-4 col-lg-6 col-md-6 col-sm-6">
                                <div class="card card-custom gutter-b card-stretch">
                                    <div class="card-body pt-4">

                                        <b-form>

                                            <b-form-group class="mt-0" description="Введите заголовок" label="Заголовок:">
                                                <b-form-input v-model.trim="item.title" placeholder="Введите Заголовок"></b-form-input>
                                            </b-form-group>

                                            <b-form-group class="mt-3" label="Контент:">
                                                <ckeditor :editor="editor" v-model="item.text" :config="editorConfig"></ckeditor>
                                            </b-form-group>
                                        </b-form>
                                    </div>
                                    <!--end::Body-->
                                </div>
                                <!--end::Card-->
                            </div>
                        </div>

                        <a @click="saveAbout" ref="save-about-button" class="btn btn-block btn-sm btn-light-success font-weight-bolder text-uppercase py-4 ">Сохранить</a>

                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="card card-custom gutter-b">
                    <div class="card-header border-0">
                        <h3 class="card-title font-weight-bolder text-dark">Баннеры</h3>
                        <div class="card-toolbar">
                        </div>
                    </div>
                    <div class="card-body">

                        <draggable class="row" :list="home.collection_banner" :options="{animation:400, handle: '.handle'}"  @change="updateSortBanner" tag="div">
                            <div v-bind:key="i" v-for="(banner, i) in home.collection_banner" class="col-xl-4 col-lg-6 col-md-6 col-sm-6 handle">
                                <div class="card card-custom gutter-b card-stretch">
                                    <div class="card-body pt-4">

                                        <div v-if="banner.imagepath" class="d-flex align-items-center mb-7">
                                            <b-img :src="$urlBackEnd(banner.imagepath)" fluid-grow alt="Fluid-grow image"></b-img>
                                        </div>

                                        <div class="mb-7">
                                            <div class="d-flex justify-content-between align-items-center">
                                                <span class="text-dark-75 font-weight-bolder mr-2">{{banner.title}}</span>
                                            </div>
                                            <div v-if="banner.subtitle" class="d-flex justify-content-between align-items-center">
                                                <span class="text-dark-75 font-weight-bolder mr-2">{{banner.subtitle}}</span>
                                            </div>
                                        </div>
                                        <!--end::Info-->
                                        <a @click="editBanner(banner)" class="btn btn-block btn-sm btn-light-success font-weight-bolder text-uppercase py-4">Редактировать</a>
                                    </div>
                                    <!--end::Body-->
                                </div>
                                <!--end::Card-->
                            </div>
                        </draggable>


                    </div>
                </div>
            </div>
        </div>


        <b-modal ref="add-slider" centered hide-footer title="Добавить слайд">
            <div class="d-block">

                <b-form-group class="mb-2" label="Изображение">

                        <b-img v-if="new_slider.image" :src="$urlBackEnd(new_slider.image)" fluid-grow alt="Fluid-grow image"></b-img>
                        <b-alert v-if="errors.slide.image" show variant="danger">Необходимо изображение</b-alert>

                    <vue-dropzone ref="myVueDropzone"
                                  id="dropzone"
                                  :options="dropzoneOptions"
                                  :useCustomSlot=true
                                  v-on:vdropzone-success="successDrop"
                                  v-on:vdropzone-max-files-exceeded="maxDrop"
                    >
                        <div class="dropzone-custom-content">
                            <b class="dropzone-custom-title">Выберите файл</b>
                            <div class="subtitle">...или перетащите его сюда</div>
                        </div>

                    </vue-dropzone>

                    <b-button v-if="new_slider.image" @click="deleteImageNewSlide" size="sm" class="mt-3" variant="danger">Удалить изображение</b-button>
                </b-form-group>

                <div class="form-group mb-2">
                    <b-form-group class="mb-2" description="Введите Заголовок" label="Заголовок:">
                        <b-form-input autocomplete="off" v-model.trim="new_slider.title" :class="{'is-invalid': errors.slide.title}" required></b-form-input>
                        <div v-if="errors.slide.title" class="invalid-feedback">{{errors.slide.title[0]}}</div>
                    </b-form-group>
                </div>

                <div class="form-group mb-2">
                    <b-form-group class="mb-2" description="Введите Подзаголовок" label="Подзаголовок (необязательно):">
                        <b-form-input autocomplete="off" v-model.trim="new_slider.subtitle" :class="{'is-invalid': errors.slide.subtitle}" required></b-form-input>
                        <div v-if="errors.slide.subtitle" class="invalid-feedback">{{errors.slide.subtitle[0]}}</div>
                    </b-form-group>
                </div>


                <div class="form-group mb-2">
                    <b-form-group class="mb-2" description="Введите ссылку кнопки" label="Ссылка кнопки:">
                        <b-form-input autocomplete="off" v-model.trim="new_slider.link" :class="{'is-invalid': errors.slide.link}" required></b-form-input>
                        <div v-if="errors.slide.link" class="invalid-feedback">{{errors.slide.link[0]}}</div>
                    </b-form-group>
                </div>

                <div class="form-group mb-2">
                    <b-form-group class="mb-2" description="Введите текст кнопки" label="Текст кнопки:">
                        <b-form-input autocomplete="off" v-model.trim="new_slider.text_link" :class="{'is-invalid': errors.slide.text_link}" required></b-form-input>
                        <div v-if="errors.slide.text_link" class="invalid-feedback">{{errors.slide.text_link[0]}}</div>
                    </b-form-group>
                </div>
            </div>

            <b-button ref="add-slider-button" class="mt-3" variant="outline-primary" block @click="addSlider">Создать</b-button>

        </b-modal>

        <b-modal ref="edit-slider" centered hide-footer title="Редактировать слайд">
            <div class="d-block">

                <b-form-group class="mb-2" label="Изображение">

                        <b-img v-if="edit_slider.image" :src="$urlBackEnd(edit_slider.image)" fluid-grow alt="Fluid-grow image"></b-img>
                        <b-alert v-if="errors.slide.image" show variant="danger">Необходимо изображение</b-alert>

                    <vue-dropzone ref="myVueDropzone"
                                  id="dropzone"
                                  :options="dropzoneOptions"
                                  :useCustomSlot=true
                                  v-on:vdropzone-success="successDropEdit"
                                  v-on:vdropzone-max-files-exceeded="maxDropEdit"
                    >
                        <div class="dropzone-custom-content">
                            <b class="dropzone-custom-title">Выберите файл</b>
                            <div class="subtitle">...или перетащите его сюда</div>
                        </div>

                    </vue-dropzone>

                    <b-button v-if="edit_slider.image" @click="deleteImageEditSlide" size="sm" class="mt-3" variant="danger">Удалить изображение</b-button>
                </b-form-group>

                <div class="form-group mb-2">
                    <b-form-group class="mb-2" description="Введите Заголовок" label="Заголовок:">
                        <b-form-input autocomplete="off" v-model.trim="edit_slider.title" :class="{'is-invalid': errors.slide.title}" required></b-form-input>
                        <div v-if="errors.slide.title" class="invalid-feedback">{{errors.slide.title[0]}}</div>
                    </b-form-group>
                </div>

                <div class="form-group mb-2">
                    <b-form-group class="mb-2" description="Введите Подзаголовок" label="Подзаголовок (необязательно):">
                        <b-form-input autocomplete="off" v-model.trim="edit_slider.subtitle" :class="{'is-invalid': errors.slide.subtitle}" required></b-form-input>
                        <div v-if="errors.slide.subtitle" class="invalid-feedback">{{errors.slide.subtitle[0]}}</div>
                    </b-form-group>
                </div>

                <div class="form-group mb-2">
                    <b-form-group class="mb-2" description="Введите ссылку кнопки" label="Ссылка кнопки:">
                        <b-form-input autocomplete="off" v-model.trim="edit_slider.link" :class="{'is-invalid': errors.slide.link}" required></b-form-input>
                        <div v-if="errors.slide.link" class="invalid-feedback">{{errors.slide.link[0]}}</div>
                    </b-form-group>
                </div>

                <div class="form-group mb-2">
                    <b-form-group class="mb-2" description="Введите текст кнопки" label="Текст кнопки:">
                        <b-form-input autocomplete="off" v-model.trim="edit_slider.text_link" :class="{'is-invalid': errors.slide.text_link}" required></b-form-input>
                        <div v-if="errors.slide.text_link" class="invalid-feedback">{{errors.slide.text_link[0]}}</div>
                    </b-form-group>
                </div>

            </div>

            <b-button ref="save-slider-button" class="mt-3" variant="outline-primary" block @click="saveSlider">Сохранить</b-button>

        </b-modal>

        <b-modal ref="edit-banner" centered hide-footer title="Редактировать баннер">
            <div class="d-block">

                <b-form-group class="mb-2" label="Изображение">

                        <b-img v-if="edit_banner.imagepath" :src="$urlBackEnd(edit_banner.imagepath)" fluid-grow alt="Fluid-grow image"></b-img>


                    <vue-dropzone ref="myVueDropzone"
                                  id="dropzone"
                                  :options="dropzoneOptionsBanner"
                                  :useCustomSlot=true
                                  v-on:vdropzone-success="successDropBannerEdit"
                                  v-on:vdropzone-max-files-exceeded="maxDropBannerEdit"
                    >
                        <div class="dropzone-custom-content">
                            <b class="dropzone-custom-title">Выберите файл</b>
                            <div class="subtitle">...или перетащите его сюда</div>
                        </div>

                    </vue-dropzone>

                </b-form-group>

                <div class="form-group mb-2">
                    <b-form-group class="mb-2" description="Введите Заголовок" label="Заголовок:">
                        <b-form-input autocomplete="off" v-model.trim="edit_banner.title" required></b-form-input>
                    </b-form-group>
                </div>

                <div class="form-group mb-2">
                    <b-form-group class="mb-2" description="Введите Подзаголовок" label="Подзаголовок (необязательно):">
                        <b-form-input autocomplete="off" v-model.trim="edit_banner.subtitle"  required></b-form-input>
                    </b-form-group>
                </div>

                <div class="form-group mb-2">
                    <b-form-group class="mb-2" description="Введите ссылку " label="Ссылка:">
                        <b-form-input autocomplete="off" v-model.trim="edit_banner.path" required></b-form-input>
                    </b-form-group>
                </div>

            </div>

            <b-button ref="save-banner-button" class="mt-3" variant="outline-primary" block @click="saveBanner">Сохранить</b-button>

        </b-modal>

    </div>
</template>

<script>
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import draggable from 'vuedraggable';
    import { mapGetters } from "vuex";
    import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
    import {
        ADD_SLIDE,
        GET_HOME_PAGE,
        SAVE_ABOUT, SAVE_BANNER, SAVE_META, SAVE_SERVICE,
        SAVE_SLIDE,
        SLIDE_REQUEST
    } from "../../../core/services/store/home.module";
    import {SET_ALERT} from "../../../core/services/store/alert.module";
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import "@ckeditor/ckeditor5-build-classic/build/translations/ru"
    import UploadAdapter from "../../../uploadadapter";
    export default {
        name: "HomePage",
        components: {
            vueDropzone: vue2Dropzone, draggable
        },
        mounted() {
            this.$store.dispatch(SET_BREADCRUMB, [{ title: "Главная страница" }]);
            this.$store.dispatch(GET_HOME_PAGE)

        },
        computed: {
            ...mapGetters({
                home: 'gettersHomePage',
                errors: 'errorsHomePage',
                load: 'getHomePageLoad'
            }),
        },

        data() {
            return {
                editor: ClassicEditor,

                editorConfig: {
                    language: "ru",
                    extraPlugins: [this.uploader],

                },

                new_slider:{
                    image: '',
                    title: '',
                    subtitle: '',
                    link: '',
                    text_link: '',
                    align_class: 'p-left'
                },

                no_save_slider:{},


                edit_banner:{
                    id: null,
                    imagepath: '',
                    title: '',
                    path: ''
                },

                edit_slider:{
                    image: '',
                    title: '',
                    subtitle: '',
                    link: '',
                    text_link: '',
                    align_class: 'p-left'
                },

                dropzoneOptions: {
                    url: this.$urlBackEnd('/api/v1/slides-image'),
                    acceptedFiles: '.jpg, .jpeg, .png,',
                    thumbnailWidth: 200,
                    maxFilesize: 8,
                    maxFiles:50,
                    headers: { "Authorization": 'Bearer ' + localStorage.getItem('id_token') },
                    parallelUploads: 1,
                    createImageThumbnails: true,
                    uploadMultiple: false,
                },

                dropzoneOptionsBanner: {
                    url: this.$urlBackEnd('/api/v1/banner-image'),
                    acceptedFiles: '.jpg, .jpeg, .png,',
                    thumbnailWidth: 200,
                    maxFilesize: 8,
                    maxFiles:50,
                    headers: { "Authorization": 'Bearer ' + localStorage.getItem('id_token') },
                    parallelUploads: 1,
                    createImageThumbnails: true,
                    uploadMultiple: false,
                },


                about: [
                    {
                        title: '5 лет на рынке',
                        text: 'Наша компания занимается оптовыми поставками различных товаров из Китая в Россию уже более 5 лет. ' +
                            'За это время мы доставили нашим клиентам десятки тысяч товарных позиций. Запустили производство продукции ' +
                            'под собственной торговой маркой "SUN-BE" часть из которой представлена на нашем сайте. Постоянным покупателей ' +
                            'мы предоставляем гибкую систему скидок. Наше преимущество - это качественные товары в кротчайшие сроки и ' +
                            'по оптимальным ценам! '
                    },
                    {
                        title: 'О нас',
                        text: 'ООО "САН-БИ" - это надежный партнёр в поиске и приобретении любых интересующих Вас товаров на ' +
                            'территории Китая. Годами наработанные отношения с различными фабриками позволяют нам быстро обработать ' +
                            'Ваш запрос и предоставить всю необходимую информацию по срокам и стоимости поставки. Вы также можете ' +
                            'самостоятельно найти фабрику, а мы осуществим проверку, закупку и доставку выбранных Вами товаров.'
                    },
                    {
                        title: 'Наши задачи',
                        text: 'Главная наша задача - предложить покупателю оригинальный, качественный и проверенный ' +
                            'товар по наиболее выгодной стоимости. Для нас важно, чтобы клиенты всегда оставались довольными, ' +
                            'а наше сотрудничество приносило только положительные эмоции. С нами вы экономите время и деньги. ' +
                            'Ведь сотрудники нашей компании всегда охотно помогут Вам с выбором необходимых товаров. Работая на ' +
                            'результат, мы достигаем лучшего!'
                    },

                ],

                service:[
                    {
                        title: 'Удобная доставка',
                        subtitle: 'Продуманная логистика с фиксированной ценой',
                    },
                    {
                        title: 'Работаем 24X7',
                        subtitle: 'Принимаем и обрабатываем заказы круглосуточно',
                    },
                    {
                        title: 'Уникальные товары',
                        subtitle: 'В наличии товары собственного производства',
                    },
                    {
                        title: 'Онлайн оплата',
                        subtitle: 'Удобные и безопасные способы оплаты'
                    }
                ],


                collection_banner: [
                    {
                        id: 1,
                        imagepath: '/storage/files/xkCrfVxd37E6gQmX.jpg',
                        title: 'Акции',
                        subtitle: 'Товары по скидкам',
                        path: ''
                    },
                    {
                        id: 2,
                        imagepath: '/storage/files/xkCrfVxd37E6gQmX.jpg',
                        title: 'Спорт',
                        path: ''
                    },
                    {
                        id: 3,
                        imagepath: '/storage/files/xkCrfVxd37E6gQmX.jpg',
                        title: 'Мебель',
                        path: ''
                    },
                    {
                        id: 4,
                        imagepath: '/storage/files/xkCrfVxd37E6gQmX.jpg',
                        title: 'Аксессуары',
                        subtitle: 'Power bank, беспроводные зарядки',
                        path: ''
                    },
                    {
                        id: 5,
                        imagepath: '/storage/files/xkCrfVxd37E6gQmX.jpg',
                        title: 'Стройматериалы',
                        path: ''
                    },
                    {
                        id: 6,
                        imagepath: '/storage/files/xkCrfVxd37E6gQmX.jpg',
                        title: 'Электрика',
                        path: ''
                    },
                    {
                        id: 7,
                        imagepath: '/storage/files/xkCrfVxd37E6gQmX.jpg',
                        title: 'Сантехника',
                        path: ''
                    },
                    {
                        id: 8,
                        imagepath: '/storage/files/xkCrfVxd37E6gQmX.jpg',
                        title: 'Разное',
                        path: ''
                    },
                    {
                        id: 9,
                        imagepath: '/storage/files/xkCrfVxd37E6gQmX.jpg',
                        title: 'Товары в наличии',
                        subtitle: 'Все товары, имеющиеся на складе',
                        path: ''
                    }
                ]

            }
        },

        methods:{

            uploader(editor)
            {
                editor.plugins.get( 'FileRepository' ).createUploadAdapter = ( loader ) => {
                    return new UploadAdapter( loader );
                };
            },

            showAlert(text, variant, type) {
                this.$store.commit(SET_ALERT, {text, variant, type});
            },

            newSlider(){
                this.$refs['add-slider'].show()
            },

            editSlide(slide){
                this.$refs['edit-slider'].show();
                this.edit_slider = slide;

            },


            saveSlider(){

                const submitButtonSaveSlide = this.$refs["save-slider-button"];
                submitButtonSaveSlide.classList.add("spinner", "spinner-light", "spinner-right");

                this.$store.dispatch(SLIDE_REQUEST, this.edit_slider)
                    .then(() => {
                        this.$store.dispatch(SAVE_SLIDE, this.home.slides)
                            .then(() => {
                                this.$refs['edit-slider'].hide();
                                this.showAlert('Слайдер успешно сохранен', 'success', 'toast');
                                this.edit_slider = {
                                    image: '',
                                    title: '',
                                    subtitle: '',
                                    link: '',
                                    text_link: '',
                                    align_class: 'p-left'
                                };
                            })
                            .catch(() => {
                                this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                            })
                            .finally(() => {
                                submitButtonSaveSlide.classList.remove("spinner", "spinner-light", "spinner-right")
                            })
                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                        }
                        submitButtonSaveSlide.classList.remove("spinner", "spinner-light", "spinner-right")
                    })


            },




            addSlider(){

                const submitButtonAddSlide = this.$refs["add-slider-button"];
                submitButtonAddSlide.classList.add("spinner", "spinner-light", "spinner-right");

                this.$store.dispatch(ADD_SLIDE, this.new_slider)
                    .then(() => {
                        this.$refs['add-slider'].hide();
                        this.showAlert('Слайдер успешно добавлен', 'success', 'toast');
                        this.new_slider = {
                            image: '',
                            title: '',
                            subtitle: '',
                            link: '',
                            text_link: '',
                            align_class: 'p-left'
                        };
                    })
                    .catch((response) => {
                        if (response.status === 422){
                            this.showAlert('Заполните все поля', 'danger', 'toast');
                        } else {
                            this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                        }
                    })
                    .finally(() => {
                        submitButtonAddSlide.classList.remove("spinner", "spinner-light", "spinner-right")
                    });

            },

            maxDrop (){
                this.showAlert('Не более одного файла', 'warning', 'toast');
            },

            successDrop (file, response) {
                this.$refs.myVueDropzone.removeAllFiles();

                this.new_slider.image = response.original;
            },

            maxDropEdit (){
                this.showAlert('Не более одного файла', 'warning', 'toast');
            },

            successDropEdit (file, response) {
                this.$refs.myVueDropzone.removeAllFiles();
                this.edit_slider.image = response.original;
            },

            maxDropBannerEdit (){
                this.showAlert('Не более одного файла', 'warning', 'toast');
            },

            successDropBannerEdit (file, response) {
                this.$refs.myVueDropzone.removeAllFiles();
                this.edit_banner.imagepath = response.original;
            },

            deleteImageNewSlide(){
                this.new_slider.image = null
            },

            deleteImageEditSlide(){
                this.edit_slider.image = null
            },

            updateSortSlider(){
                this.$store.dispatch(SAVE_SLIDE, this.home.slides)
                    .then(() => {
                        this.showAlert('Сортировка изменена', 'success', 'toast');
                    })
                    .catch(() => {
                        this.showAlert('Ошибка сортировки, проверьте соединение или попробуйте позже', 'warning', 'toast');
                    })
            },

            saveAbout(){

                const submitButtonSaveAbout = this.$refs["save-about-button"];
                submitButtonSaveAbout.classList.add("spinner", "spinner-light", "spinner-right");

                this.$store.dispatch(SAVE_ABOUT, this.home.about)
                    .then(() => {
                        this.showAlert('Блок "О нас" сохранен', 'success', 'toast');
                    })
                    .catch(() => {
                        this.showAlert('Ошибка, проверьте соединение или попробуйте позже', 'warning', 'toast');
                    })
                    .finally(() => {
                        submitButtonSaveAbout.classList.remove("spinner", "spinner-light", "spinner-right")
                    });
            },

            saveService(){

                const submitButtonSaveService = this.$refs["save-service-button"];
                submitButtonSaveService.classList.add("spinner", "spinner-light", "spinner-right");

                this.$store.dispatch(SAVE_SERVICE, this.home.service)
                    .then(() => {
                        this.showAlert('Блок "Сервисы" сохранен', 'success', 'toast');
                    })
                    .catch(() => {
                        this.showAlert('Ошибка, проверьте соединение или попробуйте позже', 'warning', 'toast');
                    })
                    .finally(() => {
                        submitButtonSaveService.classList.remove("spinner", "spinner-light", "spinner-right")
                    });
            },


            editBanner(banner){
                this.$refs['edit-banner'].show();
                this.edit_banner = banner;
            },

            saveBanner(){

                const submitButtonSaveBanner = this.$refs["save-banner-button"];
                submitButtonSaveBanner.classList.add("spinner", "spinner-light", "spinner-right");

                this.$store.dispatch(SAVE_BANNER, this.home.collection_banner)
                    .then(() => {
                        this.$refs['edit-banner'].hide();
                        this.showAlert('Баннер успешно сохранен', 'success', 'toast');
                        this.edit_slider = {
                            image: '',
                            title: '',
                            subtitle: '',
                            link: '',
                            text_link: '',
                            align_class: 'p-left'
                        };
                    })
                    .catch(() => {
                        this.showAlert('Ошибка, попробуйте позже', 'danger', 'toast');
                    })
                    .finally(() => {
                        submitButtonSaveBanner.classList.remove("spinner", "spinner-light", "spinner-right")
                    })



            },

            updateSortBanner(){
                    this.$store.dispatch(SAVE_BANNER, this.home.collection_banner)
                        .then(() => {
                            this.showAlert('Сортировка изменена', 'success', 'toast');
                        })
                        .catch(() => {
                            this.showAlert('Ошибка сортировки, проверьте соединение или попробуйте позже', 'warning', 'toast');
                        })
            },


            saveTags(){

                const submitButtonSaveMeta = this.$refs["save-meta"];
                submitButtonSaveMeta.classList.add("spinner", "spinner-light", "spinner-right");

                this.$store.dispatch(SAVE_META, {title: this.home.title, description: this.home.description})
                    .then(() => {
                        this.showAlert('Метатеги сохранены', 'success', 'toast');
                    })
                    .catch(() => {
                        this.showAlert('Ошибка сохранения, проверьте соединение или попробуйте позже', 'warning', 'toast');
                    })
                    .finally(() => {
                        submitButtonSaveMeta.classList.remove("spinner", "spinner-light", "spinner-right")
                    })

            }
        }
    }
</script>

<style scoped>

    .handle {
        cursor: move;
    }

    .btm-slider{
        cursor: pointer;
    }

</style>